const formatCurrency = number =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(
    number
  );

export default formatCurrency;
